<template>
<div>
  <h1>{{ t('DADOS_PESSOAIS') }}</h1>
  <div class="innerForm">
    <v-text-field :rules="[v => !!v  || t('VALIDATIONS.REQUIRED_FIELD')]" color="#E46C0A " type="text" :placeholder="t('FORM.NOME')" :value="name" name="Name"></v-text-field>
    <v-text-field :rules="[v => !!v || t('VALIDATIONS.REQUIRED_FIELD')]" color="#E46C0A " type="text" :placeholder="t('FORM.SOBRENOME')" :value="lastName" name="LastName"></v-text-field>
    <v-text-field color="#E46C0A " :placeholder="t('FORM.CPF')" :value="cpf && hideCpf(cpf, foreigner)" readonly></v-text-field>
    <v-text-field v-mask="['##/##/####']" v-on:change="update($event)" :rules="[
      v => testDate(v) || t('VALIDATIONS.FORMAT_DATA'),
      v => !isUnderYearsOld(v, 16) || t('VALIDATIONS.NAO_PODE_MENOR')
    ]" name="BirthDay" type="text" class="BirthDay" color="#E46C0A " :placeholder="t('FORM.DATA_NASCIMENTO')" :value="birthday && formatDate(birthday)"></v-text-field>
    <div class="div-checkbox" v-if="show1218">
      <input type="checkbox" v-model="auth" name="AuthResponsible" />
      <div class="styled-checkbox" @click="auth = !auth"><Check v-if="auth"/></div>
      <span >{{ t('FORM.ATUALIZACAO_PAIS') }}</span>
      <p class="formError inf" v-if="!auth">{{ t('VALIDATIONS.ACEITE_REQUIRED') }}</p>
    </div>
    <v-text-field  v-mask="['(##) ####-####','(##) #####-####']" :rules="[(v)=> !!v || t('VALIDATIONS.REQUIRED_FIELD')]" color="#E46C0A " type="tel" name="Phone" :placeholder="t('FORM.TELEFONE')" :value="phone"></v-text-field>
  </div> 
</div>
</template>

<script>
import {VTextField} from 'vuetify/lib'
import {mask} from 'vue-the-mask'
import {isUnderYearsOld,formatDate,hideCpf,testDate} from '../helpers/helpers'
import Check from '@/components/svg/Check.vue'
import { translate } from '../services/translate.service';
export default {
  name: 'DadosPessoaisForm',
  directives: {mask},
  props: {
      name:{
        type:String,
      },
      lastName:{
        type:String,
      },
      cpf:{
        type:String,
      },
      foreigner: {
        type: Boolean
      },
      birthday:{
        type:String,
      },
      phone:{
        type:String,
      },
      authResponsible: {
        type: Boolean
      }
  },
  data() {
    return {
      show1218: false,
      auth: true
    }
  },
  components:{
    VTextField,
    Check,
  },
  methods:{
    t:translate,
    update(value) {
      this.show1218 = isUnderYearsOld(value, 18) && !isUnderYearsOld(value, 16);
      let data = {birthday: value };
      this.$emit("update", data);
    },
    isUnderYearsOld,
    formatDate,
    hideCpf,
    testDate,
    checkValue(value){
      if(!document.querySelector(".innerForm input[name='"+value+"'")) return
      return !!document.querySelector(".innerForm input[name='"+value+"'").value
    },
  },
  updated(){
    console.log('updated', this);
    if(this.birthday && document.querySelectorAll('#input-28').length) document.querySelector('#input-28').valueAsDate = new Date(this.birthday)
    let nascimento = document.querySelector('[name="BirthDay"]').value;
    this.show1218 = isUnderYearsOld(nascimento, 18) && !isUnderYearsOld(nascimento, 16);
  }
}
</script>

<style scoped lang="scss">
 @import "../assets/scss/dadosPessoaisForm.scss";
</style>
